export function getLabelForValue(labels: string[], values: string[], currentValue: string): string {
  const index = values.indexOf(currentValue);
  return labels[index];
}
